import React from 'react';
import PropTypes from 'prop-types';
import styled from 'styled-components';
import Button from './Button';
import { Link } from 'react-router-dom';

const UnstyledLink = styled(Link)`
  text-decoration: none;
`;

function LinkButton({ children, color, to, variant, ...rest }) {
  return (
    <UnstyledLink to={to}>
      <Button {...rest} color={color} variant={variant}>
        {children}
      </Button>
    </UnstyledLink>
  );
}

LinkButton.propTypes = {
  children: PropTypes.node.isRequired,
  to: PropTypes.string.isRequired,
  color: PropTypes.string,
  variant: PropTypes.string,
};

LinkButton.defaultProps = {
  color: 'default',
  variant: 'text',
};

export default LinkButton;



// WEBPACK FOOTER //
// ./src/modules/common/LinkButton.js